export const environment = {
  production: false,
  api: 'https://dev.api.biilog.com.br/api-v1',
  apiv2: 'https://dev.api.biilog.com.br/api-v2',
  // apiv2: 'http://localhost:3000/api-v2',
  // api: 'http://localhost:3000',
};
